/* eslint-disable camelcase */
import type { KVKDetails } from 'state/__generated__/tadaahAPI';
import { useApiFreelancersKvkList } from 'state/__generated__/tadaahAPI';
import type { ErrorType } from 'state/custom-instance';

export type GetKVKDetailsHandler = {
  data: KVKDetails | undefined;
  error: ErrorType<{ [key: string]: string }> | null;
  isLoading: boolean;
  isSuccess: boolean;
  refetch: (options?: {
    throwOnError?: boolean;
    cancelRefetch?: boolean;
  }) => unknown;
};

export type GetKVKDetailsParams = {
  kvk_number: string;
};

export const useGetKVKDetails = (
  params: GetKVKDetailsParams,
  enabled: boolean,
): GetKVKDetailsHandler => {
  const { data, error, isLoading, isSuccess, refetch } =
    useApiFreelancersKvkList(params, {
      query: {
        enabled: enabled && params.kvk_number.length === 8,
        queryKey: ['kvk-details', params],
        refetchOnWindowFocus: false,
        retry: false,
      },
    });

  return {
    data: data?.data,
    error: error as ErrorType<{ [key: string]: string }> | null,
    isLoading,
    isSuccess,
    refetch,
  };
};
